@if (assessment(); as assessment) {
	@for (group of assessment.assessableGroups; track group.groupId; let groupIndex = $index) {
		@if (isGroupVisible(group)) {
			<div class="group">
				<div class="groupName" [class.active]="group.groupId === activeGroupId()" (click)="onGroupClicked.emit(group.groupId)">
					<span>{{ groupIndex + 1 }}.</span>
					<span>{{ group.name }}</span>
				</div>
			</div>
			@for (item of group.items; track item.assessableItemId; let itemIndex = $index) {
				<div
					class="itemName"
					[class.active]="item.assessableItemId === activeItemId()"
					(click)="
						onItemClicked.emit({
							groupId: group.groupId,
							itemId: item.assessableItemId,
						})
					"
				>
					@let answerIsArray = Array.isArray(item.answer);
					@let answerIsDefined = item.answer !== null && item.answer !== undefined;
					@let answerIsSet = (!answerIsArray && answerIsDefined) || (answerIsArray && item.answer.length > 0);

					@if (answerIsSet) {
						<mat-icon fontSet="fas" fontIcon="fa-check-circle" color="accent" inline />
					} @else {
						<div class="itemDoneIndicator"></div>
					}
					<span>{{ groupIndex + 1 }}.{{ itemIndex + 1 }}.</span>
					<sim-safe-html [html]="item.title" />
				</div>
			}
		}
	}
}
